import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { SettingsSidebar } from "@/components/settings/SettingsSidebar";
import { supabase } from "@/integrations/supabase/client";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<any>(null);
  const [profile, setProfile] = useState<any>(null);

  useEffect(() => {
    // Check auth and fetch profile
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        navigate("/auth");
      } else {
        setUser(session.user);
        fetchProfile(session.user.id);
      }
    });

    // Redirect to /settings/profile if on /settings
    if (location.pathname === "/settings") {
      navigate("/settings/profile", { replace: true });
    }
  }, [navigate, location.pathname]);

  const fetchProfile = async (userId: string) => {
    // This is for the current user's own profile, so all fields including email are allowed
    const { data } = await supabase
      .from("profiles")
      .select("id, username, full_name, email, avatar_url, bio, verified, company, created_at, updated_at")
      .eq("id", userId)
      .single();
    
    if (data) setProfile(data);
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-12 text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="px-6 md:px-8 lg:px-12 pt-24 sm:pt-28 lg:pt-32 pb-6 md:pb-12">
        {/* Layout with Sidebar and Content */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-12 max-w-6xl">
          <SettingsSidebar />
          <main className="flex-1 min-w-0">
            <Outlet context={{ user, profile }} />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Settings;
